<template>
    <div class="table-user">
        <btn-back :pushTo="{name: 'ReplenishmentItem', query: {planNumber: $route.query.planNumber}}" />
        <div class="table-user-header">
            <b-row class="pb-3">
                <search-field @searchValue="searchField($event)"></search-field>
            </b-row>
            <div class="d-flex mb-4 align-items-center">
                <h6><b>Shipping ID: {{$route.query.planNumber ? $route.query.planNumber : $route.params.planId}}</b></h6>
                <b-btn class="ml-auto"
                       variant="primary-user"
                       size="sm"
                       :disabled="selectedCheckbox.length === 0 || lodingButton"
                       @click="addToPlan">
                    Add to the shipping plan
                    <span v-if="lodingButton" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </b-btn>
            </div>
        </div>
        <div class="scroll-x">
            <table-element
                :row-class="rowClass"
                :items="items"
                :fields="fields"
                @sort="event => sortTable(event)">
                <b-form-checkbox
                    slot="HEAD_checkboxes"
                    slot-scope="data"
                    v-model="allCheckboxes"
                    @click.native.stop="selectedAll"
                    name="checkbox-column"
                    class="custom-control-user">
                    All
                </b-form-checkbox>
                <b-form-checkbox
                    slot="checkboxes"
                    slot-scope="data"
                    name="checkboxes"
                    :key="'checkbox'+data.index"
                    :value="data.item"
                    v-model="selectedCheckbox"
                    @click.native.stop
                    class="custom-control-user">
                </b-form-checkbox>
                <div slot="name" slot-scope="data">
                    <div v-if="data.item.status === 'suspended'" class="d-flex align-items-center">
                        <b-btn variant="link"
                               :to="{name: 'SingleProduct', params: {id: data.item.id}}"
                               v-b-popover.hover="'This product has blank required fields. Please provide required information'"
                               class="text-danger product-popover">&#9888;
                        </b-btn>
                        <span>{{data.value}}</span>
                    </div>
                    <template v-else>
                        {{data.value}}
                    </template>
                </div>
            </table-element>
        </div>
        <div class="table-user-footer">
            <table-pagination
                v-if="settingsPaginationFromApi.total >= quantityProductOnPage"
                @paginateAction="updatePagination"
                :settings="settingsPaginationFromApi"
                :perPageArray="quantityProductVariations"/>
        </div>
    </div>
</template>

<script>
    import {tableMixins, paginationMixin, routePaginationMixin, rowSelectMixin} from '@/mixins/tableMixins'

    import TableElement from '~cp/UserPanel/Elements/TableElement'
    import SearchField from '~cp/UserPanel/Elements/SearchField'

    import replenishmentAddProducts from '@/assets/js/columns/replenishmentAddProducts'
    import TablePagination from '~cp/UserPanel/Elements/TablePagination'

    export default {
        name: 'ReplenishmentAddProducts',
        mixins: [tableMixins, paginationMixin, routePaginationMixin, rowSelectMixin],
        components: {
            TableElement,
            SearchField,
            TablePagination
        },
        data() {
            return {
                lodingButton: false,
                fields: replenishmentAddProducts,
                productsId: [],
            }
        },
        created() {
            if (this.$store.state.replenishment.productListOfCurrentPlan.length === 0) {
                this.$store.commit('SET_PRODUCT_LIST', [])
            }
        },
        methods: {
            rowClass(item) {
                if (!item) return
                if (item.status === 'suspended') {
                    return 'table-danger'
                }
            },
            addToPlan() {
                this.lodingButton = true
                this.selectedCheckbox.forEach((id, index) => {
                    if (index === this.selectedCheckbox.length - 1) {
                        this.$router.push({name: 'ReplenishmentItem', query: {planNumber: this.$route.query.planNumber}})
                        this.$store.commit('ADD_TO_SHIPPING_PLAN', id)
                    } else {
                        this.$store.commit('ADD_TO_SHIPPING_PLAN', id)
                    }
                })
                this.lodingButton = false
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Replenishment/ReplenishmentAddProducts.vue